import { createAction, props } from '@ngrx/store';

export const setIsAgravisUser = createAction(
  '[Branding] Set Is Agravis User',
  props<{ isAgravisUser: boolean }>(),
);
